module.exports = "<select ng-model=\"$ctrl.param.value\" class=\"form-control\" ng-options=\"option.value as option.name for option in $ctrl.queryResultOptions\">\n</select>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/query-based-parameter.html
// module id = 441
// module chunks = 1